import React from "react";
import bgImage from "../images/Slide1.jpg";

// Custom inline CSS for zoom + fade-in-up animations
const styles = `
@keyframes slowZoom {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.08);
  }
}
.animate-slowZoom {
  animation: slowZoom 20s ease-in-out infinite alternate;
}

/* Fade in from bottom animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fadeInUp {
  opacity: 0;
  animation: fadeInUp 1.2s ease-out forwards;
}
.delay-100 {
  animation-delay: 0.1s;
}
.delay-200 {
  animation-delay: 0.2s;
}
`;

const Banner = ({ title, description }) => {
  return (
    <section className="relative h-[45vh] md:h-[55vh] flex flex-col items-center justify-center text-center overflow-hidden">
      {/* Inject animation styles */}
      <style>{styles}</style>

      {/* Background Image with smooth zoom */}
      <div
        className="absolute inset-0 bg-cover bg-center animate-slowZoom"
        style={{
          backgroundImage: `url(${bgImage})`,
          filter: "brightness(0.45) contrast(1.1)",
        }}
      />

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/70"></div>

      {/* Content */}
      <div className="relative z-10 px-6 max-w-3xl">
        <h1 className="text-3xl md:text-6xl font-extrabold text-[#D71920] tracking-tight drop-shadow-2xl animate-fadeInUp mb-4">
          {title}
        </h1>
        <p className="text-base md:text-xl text-white/90 font-medium leading-relaxed animate-fadeInUp delay-100">
          {description}
        </p>

        {/* Accent Line */}
        <div className="mt-6 w-24 h-1 bg-[#D71920] mx-auto rounded-full animate-fadeInUp delay-200" />
      </div>
    </section>
  );
};

export default Banner;

